import React from 'react';
import './Style.css'

const UISectionHeading = (props) => {
  const { secHeading } = props;
  return (
    <div>
    <h3 className="sec-heading" >{secHeading}</h3>
     <div className="headre-line"></div>
    </div>
  );
}

export default UISectionHeading;
